import { Controller } from '@organisms';
import { Button, Form, Modal } from 'antd';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { AddUpselFlowModalFormData } from './addUpsellFlowModal.types';
import { useAddUpsellFlow } from './useAddUpsellFlow';

interface AddUpselFlowModalProps {
  modalIsOpen: boolean;
  onCloseModal: () => void;
  onSuccess: () => void;
}
export const AddUpselFlowModal = ({
  modalIsOpen,
  onCloseModal,
  onSuccess,
}: AddUpselFlowModalProps) => {
  const { control, handleSubmit } = useForm<AddUpselFlowModalFormData>();

  const { createNewUpsellFlow, isLoading, isSuccess } = useAddUpsellFlow();

  useEffect(() => {
    if (isSuccess) onSuccess();
  }, [isSuccess]);

  const onSubmit = (data: AddUpselFlowModalFormData) => {
    createNewUpsellFlow({
      ...data,
      isActive: true,
    });
  };
  return (
    <Modal
      title='Adicionar fluxo'
      onCancel={onCloseModal}
      open={modalIsOpen}
      footer={false}
    >
      <Form
        onFinish={handleSubmit(onSubmit)}
        layout='vertical'
        style={{
          width: '100%',
          gap: '24px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Controller
          control={control}
          name='name'
          placeholder='Digite um nome de fácil memorização'
          label='Nome do fluxo'
          style={{
            borderRadius: 6,
          }}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 12,
          }}
        >
          <Button htmlType='button' onClick={onCloseModal}>
            Cancelar
          </Button>
          <Button type='primary' htmlType='submit' loading={isLoading}>
            Salvar
          </Button>
        </div>
      </Form>
    </Modal>
  );
};
